import { useEffect, useRef } from "react";
import { cloneDeep } from "lodash";

import { ReceiptProvider } from "../services";
import { useTypedDispatch, useTypedSelector } from "../redux/store";
import settingsReceiptProvider from "../redux/reducers/SettingsPage/ReceiptProvider";

/**
 * Keeps `settingsReceiptProvider` in sync for Accounts pages
 * (executor/car receipt checkbox visibility).
 */
export default function useReceiptProvidersBootstrap() {
	const dispatch = useTypedDispatch();
	const { connected, authorized } = useTypedSelector((state) => state.prpc);
	const subscriptionRef =
		useRef<Awaited<ReturnType<typeof ReceiptProvider.subscribe>>>(null);

	useEffect(() => {
		if (!connected || !authorized) {
			return undefined;
		}

		let active = true;

		(async () => {
			try {
				const subscription = await ReceiptProvider.subscribe(
					{},
					(state) => {
						if (!active) return;
						dispatch(
							settingsReceiptProvider.actions.setData(
								cloneDeep(state.models) as any,
							),
						);
					},
				);
				subscriptionRef.current = subscription;
			} catch (error) {
				console.error("[useReceiptProvidersBootstrap]", error);
			}
		})();

		return () => {
			active = false;
			subscriptionRef.current?.unsubscribe?.();
			subscriptionRef.current = null;
		};
	}, [connected, authorized, dispatch]);
}
